
const consigneeUserConstants = {
    validConsigneeUserHeaders: {
        'User Name*' :'name',
        'Email id' : 'email_id',
        'Phone Number' : 'phone_number',
        'Status' : 'status',
        'Consignee Reference Id': 'consignee_id',
    },
    exportAndRejectionHeaders:{
        'User Name*' :'name',
        'Email id' : 'email_id',
        'Phone Number' : 'phone_number',
        'Status' : 'status',
        'Consignee Reference Id': 'consignee_id',
    },
    consigneeUserNonMandatoryHeaders: {
    },
    validationErrorMessage: {
        name: 'User Name should not be empty',
        email: 'Email Id should not be empty',
        phone: 'Phone Number should be valid', 
        status : 'Status should not be empty',
        consignee_reference_id: 'Consignee Reference should not be empty',
    }
} 
module.exports = {consigneeUserConstants};
